
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.787","height":"26.787","viewBox":"0 0 26.787 26.787"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.322 12.277A10.045 10.045 0 1112.277 2.232a10.045 10.045 0 0110.045 10.045z","fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M25.671 25.671l-4.465-4.465","fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".4"}})])
          )
        }
      }
    